export default __webpack_public_path__ + "static/media/icon_x384.d1b6eeca.png";